module.exports = __webpack_public_path__ + "static/media/n_icon_arrow_gray.52e297bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_arrow_gray.png
// module id = 387
// module chunks = 0 1